import { render, staticRenderFns } from "./AccountUserAvatar.vue?vue&type=template&id=bb710836"
import script from "./AccountUserAvatar.vue?vue&type=script&lang=js"
export * from "./AccountUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports